<template>
  <div class="home">
    <!-- Header -->
    <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
    <!-- banner -->
    <div class="banner-box">
      <div class = "banner-text">
        <div class="banner-title">每天，都有基于轻骑兵低代码开发平台开发的应用上线</div>
        <div class="banner-desc">覆盖各行业、各种应用场景的成熟应用，给您更多的选择</div>
        <div class="banner-img"><img src="../assets/img/MallPage/add.png" alt="" class="point" @click="uploadApplication"></div>
        <div class="banner-add"><span class="point" @click="uploadApplication">上传我的应用</span></div>
      </div>
    </div>
    <div class="universal">
      <p>通用性应用</p>
      <el-row style="margin-top: 26px">
        <el-col :span="6" v-for="(item,index) in universalPageList" :key="index" class="universalCol">
          <div class="universalItem" @click="openInterestForm(item.title)">
            <div v-if="item.isHot" class="hotProduct"><div>热门产品</div></div>
            <div class="itemTitle">{{item.title}}</div>
            <div class="tagList"><span v-for="tag in item.tag" class="tag">{{tag}}</span></div>
            <div class="itemDesc">{{item.desc}}</div>
            <div class="button" @click="openInterestForm(item.title)">立即咨询</div>
          </div>
        </el-col>
      </el-row>
      <el-pagination @current-change="getUniversalData" background layout="prev, pager, next" :page-count="totalPage" style="margin-top: 25px">
      </el-pagination>
    </div>
    <div class="industryBackground">
      <div class="industry">
        <p>行业应用</p>
        <el-row style="margin-top: 60px">
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/power.png">
              <span>电力</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in powerList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/track.png">
              <span>轨道</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in trackList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/petrified.png">
              <span>石化</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in petrifiedList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/government.png">
              <span>政府</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in governmentList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 60px">
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/engineering.png">
              <span>工程</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in engineeringList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/manufacture.png">
              <span>制造</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in manufactureList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/biomedicine.png">
              <span>生物医药</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in biomedicineList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="industryItem">
            <div class="title">
              <img src="../assets/img/MallPage/other.png">
              <span>其他</span>
            </div>
            <div class="industryInfo">
              <div v-for="(item, index) in otherList" :key="index" @click="openInterestForm(item)">{{item}}</div>
            </div>
          </el-col>
        </el-row>
        <div><el-button class="upload" @click="uploadApplication"><i class="el-icon-plus"></i>&nbsp;&nbsp;上传我的应用</el-button></div>
      </div>
    </div>
    <!--联系专家-->
    <ContactExperts></ContactExperts>
    <!-- footer -->
    <FhBottom/>
<!--    <Footer></Footer>-->
    <!-- 右侧联系方式 -->
    <SideBar @openForm="openForm"></SideBar>
    <!-- 表单 -->
    <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
    <!-- 上传应用表单 -->
    <UploadApplicationForm v-show="showUploadForm" @closeUploadForm="closeUploadForm"></UploadApplicationForm>
    <!-- 立即咨询表单 -->
    <InterestForm v-if="showInterestForm" :product-name="productName" @closeInterestFrom="closeInterestFrom"></InterestForm>
    <!-- 返回顶部 -->
    <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
  </div>
</template>

<script>
  import Header from './include/Header.vue';
  import Footer from './include/Footer.vue';
  import HussarForm from "./include/HussarForm";
  import ContactExperts from './include/ContactExperts.vue';
  import SideBar from "./include/SideBar";
  import UploadApplicationForm from "./include/UploadApplicationForm";
  import InterestForm from "./include/InterestForm";
  export default {
    name: "MallPage",
    data() {
      return {
        router:'/MallPage',
        headColor:"light",
        isPageScroll: false,
        showForm: false,
        showUploadForm: false,
        showInterestForm: false,
        Interest: false,
        totalPage: 0,
        currentPage: 1, //当前页数 ，默认为1
        pageSize: 12, // 每页显示数量
        productName: '',
        universalPageList: [], //当前页显示内容
        universalAppList: [
          {title:'干部管理',isHot:true,tag:['干部画像','干部调整','干部测评'],desc:'打造“选、育、管、用”全流程的数字化平台，为精准识人，科学选人、严格用人提供有力支撑。'},
          {title:'智能运维',isHot:true,tag:['故障排查','业务软件深度监控','多机房监控'],desc:'帮助运维人员管理机房，对机房内的软件系统和硬件设备实现自动化监控，可定期生成巡检报告，实现故障预警、定位，降低故障发生率。'},
          {title:'知识库',isHot:false,tag:['企业知识收集','企业数据资产管理'],desc:'数据资产管理系统，融合知识图谱，自然语言处理，ES检索等技术，助力企业从数据中提取知识，沉淀数据资产，实现对企业知识的智能检索、问答、推荐和统一管理。'},
          {title:'即时通讯',isHot:false,tag:['新一代企业数字化OA','移动门户'],desc:'一款类微信的即时通讯产品，支持在内搭建服务器，独立部署使用，确保交流信息的安全可控。支持移动门户的快速搭建，助力政企机构高效构建新一代数字化移动办公生态。'},
          {title:'业务拨测平台',isHot:true,tag:['自动化业务探测','异常告警精准推送'],desc:'可以模拟用户真实访问系统，7*24小时主动探测核心功能的可用性，发现问题及时告警，以便运维人员及时止损；为业务系统建立一道用户侧防线，减轻业务系统运维压力。'},
          {title:'企业经营数字化管控平台',isHot:false,tag:['企业经营数据分析','企业流程管理'],desc:'是以年度预算全面达成为目标，实现各业务指标的多维分析、进度完成率的提醒预警、经营管理的深度优化、最终实现经营管理过程中的风险管控、降本增效、开源节流。'},
          {title:'合同管理系统',isHot:false,tag:['合同电子化','合同标准化'],desc:'提供合同全生命周期管理一站式平台，实现审批流程可追溯、签订过程规范化、执行过程透明化，提高合同起草效率，支持在线签章，保证合同安全。'},
          {title:'招标采购全流程数字化平台',isHot:true,tag:['计划管理','采购管理','供应商管理'],desc:'平台通过建立标准化的招标采购业务流程，实现招标采购 “业务公开、过程受控、全程在案、永久追溯”，有效防止人为干预，保障招标采购过程合法合规，实现降本增效。'},
          {title:'实验室管理系统',isHot:true,tag:['CNAS全要素覆盖','报告样式自定义'],desc:'一套符合ISO/IEC17025规范并有效帮助实验室进行CNAS评审和复审的实验室管理系统（LIMS）。'},
          {title:'电子实验记录本',isHot:true,tag:['自动生成实验报告','盘活实验数据'],desc:'一款支持用户自定义的实验记录本，用于解决企业实验室存在大量实验模板且经常需要调整；实验员依靠传统纸质材料填写实验记录，效率低、易出错；实验数据停难以有效利用等问题。'},
          {title:'满天星应用托管分发平台',isHot:false,tag:['应用分发','应用版本管理'],desc:'是一款企业级应用管理平台，可以为企业构建统一的应用分发、管理服务。方便用户查找、安装、升级应用，帮助企业统计每个应用的下载及使用情况。'},
          {title:'智慧人力资源管理平台',isHot:false,tag:['HR业务全覆盖','人力资源管理'],desc:'聚焦人力资源管理痛点，着力解决人力资源管理信息分散、业务模块间有效关联度差、管理手段落后、信息整合和自动生成效率低等问题。'},
          {title:'评标专家监管系统',isHot:false,tag:['评标专家监管系统','自动考勤'],desc:'利用物联网技术，结合人脸识别、智能手环等设备，实现专家的自助报到、自动考勤、实时监控，从而提升入场离场效率，降低评标组织、服务保障、监察的人力成本。'},
          {title:'智能仓储管理系统',isHot:true,tag:['物料管理精细化','仓储作业无纸化'],desc:'运用RFID物联网技术，实现仓储作业的快速办理，降低仓库作业出错率、库存更加准确，实现仓库实时化、高效化、合理化管理。'},
          {title:'智能生产管理系统',isHot:false,tag:['生产过程透明化','生产管理标准化'],desc:'面向企业车间执行层，实现从订单下达到产品出库的全过程管理，构建产品质量管理体系，实现质量追溯，实现生产过程的透明化，提升管理层决策效率。'},
          {title:'化工行业HSE管理平台',isHot:true,tag:['规范各项安全管理','提高HSE水平管理'],desc:'以《HSE管理体系》所要求的10大要素为建设依据，并全面覆盖国家安全生产标准化的评审标准，可有效帮助企业规范各项安全管理工作，提升HSE管理水平，降低事故发生。'},
          {title:'化工行业承包商',isHot:false,tag:['数字化移动考试','试证合一'],desc:'以《安全生产法》和《企业安全生产标准化基本规范》中关于承包商入厂考试的要求为建设依据，包括承包商及人员管理、题库维护、试卷维护、在线考试、成绩台账等5个业务模块。'},
          {title:'特殊作业票管理系统',isHot:true,tag:['拖拉拽绘制作业票','作业全流程管控'],desc:'提供票面可视化编辑器，支持用户通过拖拉拽的方式自定义编辑作业票票面及流程内置8大特殊作业票面，符合国标要求，实现预约、申请、审批到验收归档的全过程数字化，规范化管理。'},
        ],
        powerList:['低压台区终端指标计算系统','重大活动供电保障管理系统','移动智能点巡检系统','火电厂性能诊断平台','新能源发电企业物资管理系统','新能源安健环管理平台'],
        trackList:['桥梁及钢轨位移远程监测系统','城轨运检一体化智能管理平台','自动化部署管家','利刃综合数据管理平台'],
        petrifiedList:['化工行业电子作业票系统','安全风险评估管理平台','化工行业承包商入厂考试系统','化工行业承包商管理平台','化工行业HSE管理系统','化工行业应急指挥平台'],
        governmentList:['科技管理一站式解决方案','绩效考核管理系统','社会矛盾纠纷调处化解平台','应急指挥技术支撑系统','退役军人综合服务平台','智慧党建'],
        engineeringList:['工程目标管理系统','工程施工分包管理部门','工程成本管理系统','工程项目隐患排查治理系统','工程物资管理系统','工程验收量化系统'],
        manufactureList:['制造业智能生产管理系统','智能仓储管理系统'],
        biomedicineList:['数字化药企解决方案','实验室信息管理系统','智能仓储管理系统'],
        otherList:['保险销售支持平台','智慧共享图书','培训考试平台','易学习'],
      };
    },
    components: {
      InterestForm,
      UploadApplicationForm,
      Header,
      HussarForm,
      Footer,
      SideBar,
      ContactExperts,
    },
    watch: {

    },
    methods: {
      openForm() {
        const self = this;
        self.showForm = true;
      },
      closeForm() {
        const self = this;
        self.showForm = false;
      },
      // 页面滚动
      handleNavScroll() {
        const self = this;
        self.isPageScroll = false;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > 80) {
          self.isPageScroll = true;
          self.headColor = 'dark';
        }else{
          self.headColor = 'light';
        }
      },
      // 返回顶部
      backTop() {
        $('html ,body').animate({scrollTop: 0}, 700);
      },
      getUniversalData(currentPage,scroll){
        this.totalPage=Math.ceil(this.universalAppList.length / this.pageSize);
        this.totalPage = this.totalPage === 0 ? 1 : this.totalPage;
        let begin = (currentPage - 1) * this.pageSize;
        let end = currentPage * this.pageSize;
        this.universalPageList = this.universalAppList.slice(begin, end);
        if(scroll !== 0){
          window.scrollTo({top: 458, behavior: 'smooth',});
        }
      },
      //上传应用
      uploadApplication(){
        const self = this;
        self.showUploadForm = true;
      },
      closeUploadForm() {
        const self = this;
        self.showUploadForm = false;
      },
      openInterestForm(productName){
        const self = this
        self.productName = productName
        self.showInterestForm = true;
      },
      closeInterestFrom() {
        const self = this
        self.showInterestForm = false;
      }
    },
    mounted() {
      const self = this;
      self.getUniversalData(1,0)
      window.addEventListener('scroll', self.handleNavScroll);
    },
    created() {

    },
  }
</script>

<style scoped>
  .home {color: #2E2E2E;background: #ffffff}
  .banner-box{width:100%;height:458px;background: url("../assets/img/MallPage/banner-bg.png") no-repeat;margin: 0 auto;background-size: cover;}
  .banner-text{width:1200px;color: #FFFFFF;text-align: center;padding-top:158px;margin:  0 auto;}
  .banner-title{font-size: 40px;font-weight: bold;}
  .banner-desc{font-size: 22px;font-weight: 400;margin-top: 27px; line-height: 30px}
  .banner-img{margin-top: 49px}
  .banner-add{font-size: 18px;color: #F19F35;}
  /* 返回顶部 */
  .back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
  .universalCol{padding-top: 10px;height: 368px}
  .universal{text-align: center;width: 1200px;margin: 0 auto;margin-bottom: 70px;margin-top: 76px}
  .universal p, .industry p{font-size: 34px;font-weight: bold;color: #2E2E2E;}
  .universalItem{width: 282px;height: 312px;background: url('../assets/img/MallPage/white-bg.png');margin: 23px auto;padding: 25px 20px;text-align: left;}
  .universalItem:hover{transform: translate(0,-10px);transition: all 500ms ease;background: url('../assets/img/MallPage/blue-bg.png');cursor: pointer}
  .universalItem:hover .itemTitle,.universalItem:hover .itemDesc{color: #ffffff}
  .universalItem:hover .tagList .tag{color: #ffffff;border: 1px solid #ffffff;}
  .universalItem:hover .button{color: #186CF5;background:#ffffff;cursor: pointer}
  .universalItem .itemTitle{font-size: 20px;font-weight: bold;color: #2E2E2E;}
  .universalItem .tagList{margin-top: 20px}
  .universalItem .tagList .tag{border: 1px solid #A7A7A7;padding: 2px 3px;color: #A7A7A7;margin-right: 7px}
  .universalItem .tagList .tag:last-child{margin-right: 0}
  .universalItem .itemDesc {
    margin-top: 25px;
    font-size: 14px;
    font-weight: 400;
    color: #2E2E2E;
    line-height: 26px;
    height: 124px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }
  .universalItem .button {
    background: linear-gradient(to right, #018DFF, #1A74F1);
    border-radius: 18px;
    color: #ffffff;
    width: 90px;
    height: 28px;
    line-height: 29px;
    text-align: center;
    margin-top: 24px;
  }
  .hotProduct{background: url('../assets/img/MallPage/flag.png');height: 60px;width: 60px;position: absolute;margin-top: -28px;margin-left: 205px;}
  .hotProduct div{-webkit-transform: rotate(45deg);margin-top: 17px;margin-left: 9px;width: 51px;height: 27px;font-size: 12px;color: #ffffff;}
  .industryBackground{background: #F9FBFE}
  .industry{width: 1200px;text-align: center;margin: 0 auto;padding-top: 66px;padding-bottom: 55px}
  .industryItem .title{display: flex;justify-content: center;align-items: center;border-bottom: 1px solid #C9C9C9;padding-bottom: 18px;}
  .industryItem .title img{height: 30px}
  .industryItem .title span{font-size: 22px;font-weight: bold;color: #2E2E2E;margin-left: 10px}
  .industryItem .industryInfo {padding-top: 40px;height: 324px}
  .industryItem .industryInfo div{font-size: 16px;font-weight: 400;color: #2E2E2E;margin-bottom: 24px;}
  .industryItem .industryInfo div:hover{color: #186CF5;cursor: pointer}
  .industryItem:hover .industryInfo{background: -webkit-linear-gradient(#E8F2FF,#F9FBFE);}
  .upload{border-radius: 5px 5px 5px 5px;border-color: #186CF5;color: #186CF5;width: 158px;font-size: 16px;}
  .upload:hover{background: #E1EDFF}
  .home >>>.header-box{background: rgba(255, 255, 255, 0);}
  .home >>>.header-fixed {position: fixed;background: rgba(255, 255, 255, 1);z-index: 99;transition: all .45s ease;}
  .home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}
  .home >>>.nav-light >.navigator .isActive{color: #fff}
  .home >>>.nav-light >.navigator .isActive::after{background: #fff}
  .point {cursor: pointer}
</style>




// WEBPACK FOOTER //
// src/components/MallPage.vue